import React from "react";
import { FontAwesomeIcon } from "../../../../CommonComponents/AssetsHelper";

class StepProgress extends React.Component {
    render() {
        const { stepCompleted, selectedNetworkId, hasFeed, onGoToPublish, onGoToSelectSource, collectingContent } = this.props;

        const isNetworkSelected = Boolean(selectedNetworkId);
        const isStep1Done = isNetworkSelected || stepCompleted >= 1;
        const isStep2Done = stepCompleted >= 2;
        // once a feed has been created, let the user jump straight to Publish from the top stepper instead of only ever moving forward - this stays true even after "Change source" clears postCount
        const canGoToPublish = Boolean(hasFeed);
        // reaching stepCompleted 2 already means "on the Publish step" - there's no separate "step 3 finished" state in this flow
        const isOnStep3 = isStep2Done || canGoToPublish;
        // until a feed exists, let the user jump back to Select Source from the top stepper (same as "Change source")
        const canGoToSelectSource = !hasFeed && !collectingContent && stepCompleted >= 1;

        const label1Active = isStep1Done;

        const circle2Active = isStep1Done;
        const label2Active = isStep2Done;

        // on the Publish step, Publish itself isn't done yet (that happens on the Publish click) - same look as step 2 while on step 2
        const circle3Active = isOnStep3;

        let barWidth = "0%";
        if (isOnStep3) {
            barWidth = "75%";
        } else if (isStep1Done) {
            barWidth = "34%";
        }

        return (
            <div className="ob-top-stepper">
                <div className="ob-top-stepper-row">
                    {/* Step 1 */}
                    <div className={`ob-top-stepper-item active ${canGoToSelectSource ? 'clickable' : ''}`} onClick={canGoToSelectSource ? onGoToSelectSource : undefined}>
                        <span className="ob-top-stepper-circle active">1</span>
                        <span className={`ob-top-stepper-label ${label1Active ? 'active' : ''}`}>Select Source</span>
                    </div>

                    <FontAwesomeIcon type={'solid'} icon={'angle-right'} iconClass={'ob-top-stepper-chevron'} />

                    {/* Step 2 */}
                    <div className={`ob-top-stepper-item ${circle2Active ? 'active' : ''}`}>
                        <span className={`ob-top-stepper-circle ${circle2Active ? 'active' : ''}`}>2</span>
                        <span className={`ob-top-stepper-label ${label2Active ? 'active' : ''}`}>Add Content</span>
                    </div>

                    <FontAwesomeIcon type={'solid'} icon={'angle-right'} iconClass={'ob-top-stepper-chevron'} />

                    {/* Step 3 */}
                    <div className={`ob-top-stepper-item ${circle3Active ? 'active' : ''} ${canGoToPublish ? 'clickable' : ''}`} onClick={canGoToPublish ? onGoToPublish : undefined}>
                        <span className={`ob-top-stepper-circle ${circle3Active ? 'active' : ''}`}>3</span>
                        <span className="ob-top-stepper-label">Publish</span>
                    </div>
                </div>

                <div className="ob-top-stepper-bar">
                    <div className="ob-top-stepper-bar-fill" style={{ width: barWidth }} />
                </div>
            </div>
        );
    }
}

export default StepProgress;
